import { Icon } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import Button from "./Button";
import Card, { CardVariant } from "./Card";
import Typography from "./Typography";

type MetricCardProps = {
    title: string;
    value?: React.ReactNode;
    variant?: CardVariant;
    icon?: Icon;
    href?: string;
};

const MetricCard = ({
    title,
    value,
    variant = "success",
    icon: Icon,
    href,
}: MetricCardProps) => {
    return (
        <Card variant={variant} className="py-4 px-6">
            <Typography variant="title-medium" component="h3" className="mb-4">
                {title}
            </Typography>
            <div className="flex items-end justify-between">
                <div className="flex items-center gap-6">
                    <Typography
                        variant="display-large"
                        component="span"
                        className="mt-auto align-bottom md:text-4xl xl:text-6xl"
                    >
                        {value ?? "--"}
                    </Typography>
                    {Icon && (
                        <Icon
                            weight="light"
                            size={32}
                            className={
                                variant === "success"
                                    ? "text-soft-green-80"
                                    : ""
                            }
                        />
                    )}
                </div>
                {href && (
                    <Link to={href}>
                        <Button
                            variant={
                                variant === "success" ? "primary" : "outline"
                            }
                            className="text-surface-dark"
                        >
                            View
                        </Button>
                    </Link>
                )}
            </div>
        </Card>
    );
};

export default MetricCard;
